export default __webpack_public_path__ + "static/media/cs_icon_04.fca73943.png";